module.exports = __webpack_public_path__ + "img/build-to-rent-furnished-2.632e164b.jpg";